var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('splitpanes',{staticClass:"default-theme"},[_c('pane',{attrs:{"size":"12"}},[_c('bd-aside')],1),_c('pane',[_c('bd-main')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }